import { render } from "./two-factor.vue?vue&type=template&id=48ab723f"
import script from "./two-factor.vue?vue&type=script&lang=js"
export * from "./two-factor.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/pages/profile/two-factor.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "48ab723f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('48ab723f', __exports__)) {
    console.log('reload')
    api.reload('48ab723f', __exports__)
  }
  
  module.hot.accept("./two-factor.vue?vue&type=template&id=48ab723f", () => {
    console.log('re-render')
    api.rerender('48ab723f', render)
  })

}


export default __exports__